export default  {"src":"/_next/static/image/public/clearme_logo_results.dcb5a277a71efb4c24963153336cf2ea.svg","height":96,"width":108};